module.exports = __webpack_public_path__ + "img/zs3.d18f8f6d.png";